import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ContentChild, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@app/core/services/translate.service';

@Component({
    selector: 'tt-step',
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class StepComponent implements OnChanges {
    @ContentChild(TemplateRef)
    public content?: TemplateRef<any>;

    @Input()
    public ttLabel: string = '';

    /**
     * @default true
     */
    @Input()
    public get ttTranslateLabel(): boolean {
        return this._translateLabel;
    }
    public set ttTranslateLabel(value: BooleanInput) {
        this._translateLabel = coerceBooleanProperty(value);
    }
    private _translateLabel = true;

    public label = '';

    /**
     * @default false
     */
    @Input()
    public get ttComplete(): boolean {
        return this._complete;
    }
    public set ttComplete(value: BooleanInput) {
        this._complete = coerceBooleanProperty(value);
    }
    private _complete = false;

    @Output()
    public ttCompleteChange = new EventEmitter<boolean>();

    /**
     * @default false
     */
    @Input()
    public get ttInvalid(): boolean {
        return this._invalid;
    }
    public set ttInvalid(value: BooleanInput) {
        this._invalid = coerceBooleanProperty(value);
    }
    private _invalid = false;

    @Output()
    public ttInvalidChange = new EventEmitter<boolean>();

    constructor(
        public elementRef: ElementRef<HTMLElement>,
        private translate: TranslateService,
    ) {}

    public async setLabel() {
        if (this.ttTranslateLabel) {
            this.label = await this.translate.translate(this.ttLabel);
        } else {
            this.label = this.ttLabel ?? '';
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttComplete']) {
            this.ttComplete = changes['ttComplete'].currentValue;
        }

        if (changes['ttInvalid']) {
            this.ttInvalid = changes['ttInvalid'].currentValue;
        }

        if (changes['ttTranslateLabel']) {
            this.ttTranslateLabel = changes['ttTranslateLabel'].currentValue;
        }

        if (changes['ttTranslateLabel'] || changes['ttLabel']) {
            this.setLabel();
        }
    }
}
